export class ClosureNotificationMessageGetResponse {
  notificationId?: string
  message?: string
}
